import StackedAreaChart from "./StackedAreaChart";
import LineChart from "./LineChart";
import Map from "./Map";
import {
  getXAxisTitle,
  getDateType,
} from "../../HelperFunctions/utilityFunctions";
import { useState } from "react";

const ChartGroup = ({
  chartRef,
  chartTitle,
  chartSubtitle,
  fuel,
  toolConfig,
  selectedEntity,
  selectedCountry,
  selectedCountries,
  data,
  isLoading,
  selectedYear,
  setSelectedYear,
  maxValue,
}) => {
  const [sliderValue, setSliderValue] = useState(2021);

  let renderedChart;

  const us_exclusion_datasets = ["capacity_monthly", "capacity_yearly"];

  if (
    selectedEntity === "United States" &&
    us_exclusion_datasets.includes(toolConfig.dataset.value)
  ) {
    return (
      <div className="no-data-label">
        We currently do not have capacity data for US states.
      </div>
    );
  }

  if (toolConfig.chartType === "area") {
    renderedChart = (
      <StackedAreaChart
        chartRef={chartRef}
        chartTitle={chartTitle}
        chartSubtitle={chartSubtitle}
        isLoading={isLoading}
        chartData={data}
        fuel={fuel}
        dataTreatment={toolConfig.dataTreatment}
        xAxisTitle={getXAxisTitle(toolConfig.dataset)}
        temporalResolution={toolConfig.dataset.temporalResolution}
        dateType={getDateType(toolConfig.dataset)}
      />
    );
  } else if (toolConfig.chartType === "line") {
    renderedChart = (
      <LineChart
        chartRef={chartRef}
        chartTitle={chartTitle}
        chartSubtitle={chartSubtitle}
        isLoading={isLoading}
        chartData={data}
        fuel={fuel}
        dataTreatment={toolConfig.dataTreatment}
        xAxisTitle={getXAxisTitle(toolConfig.dataset)}
        temporalResolution={toolConfig.dataset.temporalResolution}
        dateType={getDateType(toolConfig.dataset)}
        comparison={toolConfig.comparison}
      />
    );
  } else if (toolConfig.chartType === "map") {
    renderedChart = (
      <Map
        chartRef={chartRef}
        chartTitle={chartTitle}
        chartSubtitle={chartSubtitle}
        isLoading={isLoading}
        data={data}
        selectedYear={selectedYear}
        setSelectedYear={(option) => setSelectedYear(option)}
        maxValue={maxValue}
        sliderValue={sliderValue}
        setSliderValue={(value) => setSliderValue(value)}
        fuel={fuel}
        datasetTitle={toolConfig.dataset.value}
      />
    );
  } else {
    renderedChart = <div>Choose a chart type</div>;
  }

  return renderedChart;
};

export default ChartGroup;
